import { section } from '@/glow';
import { AnimateLogoList } from '@/lib/animation';

section('logo-list', {
  onLoad() {
    this.AnimateLogoList = AnimateLogoList(this.container);
  },

  onUnload() {
    this.AnimateLogoList?.destroy();
  }
});
